"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var environment_1 = require("./environments/environment");
var analytics_scripts_1 = require("./analytics-scripts");
var initializeIntercom_1 = require("./analytics-scripts/initializeIntercom");
var __NgCli_bootstrap_1 = require("./app/app.module.ngfactory");
var __NgCli_bootstrap_2 = require("@angular/platform-browser");
if (environment_1.environment.production) {
    core_1.enableProdMode();
    analytics_scripts_1.initializeGoogleAnalytics();
    analytics_scripts_1.initilizeGoogleTagManager();
    analytics_scripts_1.facebookPixelInitialize();
    initializeIntercom_1.initializeIntercom();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch(function (err) { return console.log(err); });
